/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.EmployeeGoal {
    angular.module('meevo.plugins.employeeGoal', []);
}